var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOillifeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14.76px",
    viewBox: "0 0 24 14.76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Safety/SafetyAlert/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Health_Warning_02",
    transform: "translate(-36.000000, -718.440000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Health_Tile_Warning-Copy-6",
    transform: "translate(20.000000, 694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety/SafetyAlert/32",
    transform: "translate(16.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 1.77635684e-15,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,15.6 L20.4,15.6 C20.4,16.92 19.32,18 18,18 C16.68,18 15.6,16.92 15.6,15.6 L14.4,15.6 C14.4,16.92 13.32,18 12,18 C10.68,18 9.6,16.92 9.6,15.6 L8.4,15.6 C8.4,16.92 7.32,18 6,18 C4.68,18 3.6,16.92 3.6,15.6 L2.4,15.6 C2.4,16.92 1.32,18 1.77635684e-15,18 L1.77635684e-15,19.2 C1.26,19.2 2.34,18.54 3,17.58 C3.66,18.54 4.74,19.2 6,19.2 C7.26,19.2 8.34,18.54 9,17.58 C9.66,18.54 10.74,19.2 12,19.2 C13.26,19.2 14.34,18.54 15,17.58 C15.66,18.54 16.74,19.2 18,19.2 C19.26,19.2 20.34,18.54 21,17.58 C21.66,18.54 22.74,19.2 24,19.2 L24,18 C22.68,18 21.6,16.92 21.6,15.6 Z M22.8,9.6 C22.8,9.6 24,11.34 24,12 C24,12.66 23.46,13.2 22.8,13.2 C22.14,13.2 21.6,12.66 21.6,12 C21.6,11.34 22.8,9.6 22.8,9.6 Z M1.32,4.44 L6,6.3 L6,7.2 L8.4,7.2 L8.4,6 L7.2,6 L7.2,4.8 L10.8,4.8 L10.8,6 L9.6,6 L9.6,7.2 L12,7.2 L13.14,8.28 L21.84,6.9 L23.04,8.1 L22.2,9 L21.42,8.22 L20.4,8.4 L15.6,13.2 L4.8,13.2 L4.8,9.72 L3.01980663e-14,7.8 L1.32,4.44 Z M11.52,8.4 L6,8.4 L6,12 L15.12,12 L18.36,8.76 L12.72,9.6 L11.52,8.4 Z M1.98,6 L1.56,7.14 L4.8,8.4 L4.8,7.14 L1.98,6 Z",
    id: "Icon",
    fill: "#00095B",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOillifeIcon);
export default __webpack_public_path__ + "static/media/oillife-icon.ba5e5a2f8bf553cb515519f1995085dc.svg";
export { ForwardRef as ReactComponent };